import 'leaflet/dist/leaflet.css';
import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';

// Fix default icon issue with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const goldIcon = L.divIcon({
  className: 'custom-marker',
  html: `<div style="background:#153e44;border:3px solid #075a6d;width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 4px 10px rgba(0,0,0,0.3);display:flex;align-items:center;justify-content:center;"><div style="transform:rotate(45deg);color:#075a6d;font-weight:bold;font-size:12px;">⚖</div></div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
});

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 0) return;
    if (points.length === 1) {
      map.setView([points[0].lat, points[0].lng], 12);
    } else {
      const bounds = L.latLngBounds(points.map(p => [p.lat, p.lng]));
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 12 });
    }
  }, [points, map]);
  return null;
}

export default function FirmsMap({ firms = [], height = 500, singleFirm = null }) {
  // Build points from firms (grouped by city; add small jitter so multiple firms per city aren't stacked)
  const points = firms
    .filter(f => f.lat != null && f.lng != null)
    .map((f, i) => ({
      ...f,
      lat: f.lat + (i % 5) * 0.005,
      lng: f.lng + (i % 7) * 0.005,
    }));

  if (singleFirm && singleFirm.lat != null) {
    points.push({ ...singleFirm, lat: singleFirm.lat, lng: singleFirm.lng });
  }

  const center = points.length > 0 ? [points[0].lat, points[0].lng] : [-14.235, -51.925];

  return (
    <div className="rounded-[10px] overflow-hidden border border-[#cbd8dc]" style={{ height }}>
      <MapContainer center={center} zoom={4} style={{ height: '100%', width: '100%' }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points} />
        {points.map((f, i) => (
          <Marker key={f.id + '-' + i} position={[f.lat, f.lng]} icon={goldIcon}>
            <Popup>
              <div style={{ minWidth: 200 }}>
                <div style={{ fontWeight: 700, color: '#153e44' }}>{f.name}</div>
                {f.leadLawyer && <div style={{ fontSize: 12, color: '#64748b' }}>{f.leadLawyer}</div>}
                {f.cityName && <div style={{ fontSize: 12, color: '#64748b' }}>{f.cityName}/{f.state}</div>}
                {f.slug && (
                  <a href={`/escritorio/${f.slug}`} style={{ display: 'inline-block', marginTop: 8, padding: '4px 10px', background: '#153e44', color: '#075a6d', borderRadius: 6, fontSize: 12, fontWeight: 600, textDecoration: 'none' }}>
                    Ver perfil
                  </a>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
